
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4.5 4.25a2.75 2.75 0 115.5 0 2.75 2.75 0 01-5.5 0zM7.25 0a4.25 4.25 0 100 8.5 4.25 4.25 0 000-8.5zm7.25 5.25a1.75 1.75 0 113.5 0 1.75 1.75 0 01-3.5 0zM16.25 2a3.25 3.25 0 100 6.5 3.25 3.25 0 000-6.5zM2.224 11.433C3.55 10.508 5.331 10 7.25 10c1.894 0 3.655.495 4.974 1.398.128-.117.263-.227.406-.33.963-.694 2.248-1.068 3.62-1.068 1.372 0 2.657.374 3.62 1.069.973.7 1.63 1.745 1.63 3.014a2.417 2.417 0 01-2.417 2.417h-4.779a3.085 3.085 0 01-2.887 2H3.083A3.083 3.083 0 010 15.417c0-1.675.89-3.053 2.224-3.984zM14.481 15h4.602c.507 0 .917-.41.917-.917 0-.703-.35-1.325-1.006-1.797-.666-.48-1.63-.786-2.744-.786-1.114 0-2.078.306-2.743.786a3.099 3.099 0 00-.151.115c.626.728 1.035 1.605 1.125 2.599zM3.083 12.663C2.064 13.374 1.5 14.33 1.5 15.417 1.5 16.29 2.209 17 3.083 17h8.334C12.29 17 13 16.291 13 15.417c0-1.087-.564-2.043-1.583-2.754C10.389 11.945 8.92 11.5 7.25 11.5c-1.67 0-3.139.445-4.167 1.163z","fill":"#fff"}})])
          )
        }
      }
    